import { useTranslation } from 'react-i18next'

import {
  getBirdviewDwellerAnnouncements,
  getBirdviewDwellerDocuments,
  getBirdviewDwellerHome,
  getBirdviewDwellerMessages,
  getBirdviewDwellerObjects,
  getBirdviewDwellerRequests,
} from '../../../../api'
import { useUserData } from '../../../../hooks'
import { getUserId } from '../../../../utils/user'
import {
  getBirdviewFirstPageParams,
  toBirdviewListSection,
} from '../../DashboardBirdview.utils.api'
import { useBirdviewRequestLoaders } from '../useBirdviewRequestLoaders'

import {
  toBirdviewAnnouncementItem,
  toBirdviewDocumentItem,
  toBirdviewDwellerRequestItem,
  toBirdviewHomeSection,
  toBirdviewMessageItem,
  toBirdviewObjectItem,
} from './useBirdviewDwellerLoaders.utils'

export function useBirdviewDwellerLoaders() {
  const { t } = useTranslation()

  const user = useUserData()

  const { getRequestsExtra } = useBirdviewRequestLoaders()

  const userId = getUserId(user)

  async function getDwellerRequestsSection() {
    const { data } = await getBirdviewDwellerRequests(
      getBirdviewFirstPageParams()
    )

    return {
      ...toBirdviewListSection(data, toBirdviewDwellerRequestItem),
      extra: await getRequestsExtra(data.items),
    }
  }

  async function getDwellerAnnouncementsSection() {
    const { data } = await getBirdviewDwellerAnnouncements(
      getBirdviewFirstPageParams()
    )

    return toBirdviewListSection(data, toBirdviewAnnouncementItem)
  }

  async function getDwellerMessagesSection() {
    const { data } = await getBirdviewDwellerMessages(
      getBirdviewFirstPageParams()
    )

    return toBirdviewListSection(data, chat =>
      toBirdviewMessageItem(chat, userId)
    )
  }

  async function getDwellerDocumentsSection() {
    const { data } = await getBirdviewDwellerDocuments(
      getBirdviewFirstPageParams()
    )

    return toBirdviewListSection(data, document =>
      toBirdviewDocumentItem(document, t)
    )
  }

  async function getDwellerHomeSection() {
    const { data } = await getBirdviewDwellerHome()

    return toBirdviewHomeSection(data.items, t)
  }

  async function getDwellerObjectsSection() {
    const { data } = await getBirdviewDwellerObjects(
      getBirdviewFirstPageParams()
    )

    return toBirdviewListSection(data, flat => toBirdviewObjectItem(flat, t))
  }

  return {
    getDwellerAnnouncementsSection,
    getDwellerDocumentsSection,
    getDwellerHomeSection,
    getDwellerMessagesSection,
    getDwellerObjectsSection,
    getDwellerRequestsSection,
  }
}
